import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Loading } from "@/components/auth/RequireAuth";
import { useApi, errMsg, pkr, dateRange } from "@/lib/api";

const STATUS = { confirmed: "Confirmed", pending_payment: "Awaiting payment", cancelled: "Cancelled", refunded: "Refunded" };

export default function Trips() {
  const api = useApi();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/bookings").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e))); }, [api]);
  if (!items) return <Loading />;
  return (
    <div className="mx-auto max-w-5xl px-5 py-14 md:px-8" data-testid="trips-page">
      <div className="eyebrow text-secondary">Guest mode</div>
      <h1 className="mt-2 text-4xl tracking-tight text-primary sm:text-5xl">My trips</h1>
      {items.length === 0 ? (
        <div className="mt-10 rounded-2xl border border-dashed border-border p-10" data-testid="trips-empty">
          <p className="text-muted-foreground">No trips yet.</p>
          <Button asChild className="mt-4 rounded-full"><Link to="/guide-me">Find a getaway</Link></Button>
        </div>
      ) : (
        <div className="mt-10 space-y-4">
          {items.map((b) => (
            <div key={b.id} className="flex flex-col gap-5 rounded-2xl border border-border bg-white p-4 sm:flex-row sm:items-center" data-testid={`trip-row-${b.id}`}>
              <img src={b.listing?.hero_image} alt="" className="h-28 w-full rounded-lg object-cover sm:w-40" />
              <div className="flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <Badge variant={b.status === "confirmed" ? "default" : "secondary"}>{STATUS[b.status] || b.status}</Badge>
                  <span className="text-xs text-muted-foreground">{b.code}</span>
                  {!b.is_owner && <Badge variant="outline">Invited guest</Badge>}
                </div>
                <div className="mt-2 font-display text-xl">{b.listing?.title}</div>
                <div className="text-sm text-muted-foreground">{dateRange(b.listing?.start_date, b.listing?.end_date)} · {b.kind === "private" ? "Private buy-out" : `${b.seats} seat(s)`} · {pkr(b.total)}</div>
              </div>
              {b.status === "pending_payment" ? (
                <Button asChild className="rounded-full bg-secondary hover:bg-secondary/90" data-testid={`trip-pay-${b.id}`}><Link to={`/checkout/${b.id}`}>Complete payment</Link></Button>
              ) : (
                <Button asChild variant="outline" className="rounded-full" data-testid={`trip-open-${b.id}`}><Link to={`/trips/${b.id}`}>Open portal</Link></Button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
